import { useState } from "react";
import Card from "../../components/Card/Card";
import { CardMapValue } from "../../Layout/CardLayout";
import styles from "../../shared-styles/Category.module.css";
import { useGetOfferListingsQuery } from "../../store/listing/fetchStateListingThunk";
import Button from "../../components/Button/Button";
import ClipLoader from "react-spinners/esm/ClipLoader";
import loadingStyles from "../../shared-styles/loading.module.css";

export default function Offers() {
  const [NumberCardsAppear, setNumberCardsAppear] = useState(3);
  const { data, isLoading, isError } = useGetOfferListingsQuery({});

  if (isLoading)
    return (
      <div className={loadingStyles.loading}>
        <ClipLoader loading size={200} color="#35a257" />
      </div>
    );
  if (isError) return <h1>Error</h1>;
  if (data.length === 0) {
    return (
      <section className={`${styles.layout} container`}>
        <p>There is not Places for offers </p>
      </section>
    );
  }

  function handelClick() {
    setNumberCardsAppear((prev) => prev + 3);
  }

  return (
    <section className={styles.layout}>
      <div className={`container`}>
        <h1>Offers</h1>
        <ul className={styles.cardLayout}>
          {data?.slice(0, NumberCardsAppear).map((item: CardMapValue) => {
            return <Card key={item.id} item={item} edit={false} />;
          })}
        </ul>
      </div>
      <div className={`container ${styles.showMore}`}>
        <Button
          className="primary"
          onClick={handelClick}
          disabled={data.length <= NumberCardsAppear}
        >
          Show More
        </Button>
      </div>
    </section>
  );
}
